var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnquiryNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 232,
    viewBox: "0 0 558 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_105_31634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.329 7.27056H521.528C523.769 7.27056 525.586 9.08759 525.586 11.329V135.247C525.586 137.488 523.769 139.305 521.528 139.305H12.329C10.0876 139.305 8.27056 137.488 8.27056 135.247V11.329C8.27056 9.08759 10.0876 7.27056 12.329 7.27056Z",
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 0.541125
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 83.2168,
    y: 23.2344,
    width: 128.247,
    height: 5.95238,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 83.2168,
    y: 35.1387,
    width: 52.4892,
    height: 5.95238,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 83.2168,
    y: 47.043,
    width: 52.4892,
    height: 5.95238,
    fill: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 83.2168,
    y: 121.178,
    width: 52.4892,
    height: 5.95238,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.9252,
    cy: 36.7625,
    rx: 13.5737,
    ry: 13.5281,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.537,
    y: 21.6113,
    width: 61.6883,
    height: 19.4805,
    rx: 1.08225,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.473,
    y: 21.6113,
    width: 19.4805,
    height: 19.4805,
    rx: 1.08225,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3516 109.273H513.953V109.815H32.3516V109.273Z",
    fill: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0176,
    y: 75.1641,
    width: 19.4805,
    height: 19.4805,
    rx: 1.08225,
    fill: "#F9F9F9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_105_31634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.329 90.2706H545.528C547.769 90.2706 549.586 92.0876 549.586 94.329V218.247C549.586 220.488 547.769 222.305 545.528 222.305H36.329C34.0876 222.305 32.2706 220.488 32.2706 218.247V94.329C32.2706 92.0876 34.0876 90.2706 36.329 90.2706Z",
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 0.541125
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 107.217,
    y: 106.234,
    width: 128.247,
    height: 5.95238,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 107.217,
    y: 118.139,
    width: 52.4892,
    height: 5.95238,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 107.217,
    y: 130.043,
    width: 52.4892,
    height: 5.95238,
    fill: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 107.217,
    y: 204.178,
    width: 52.4892,
    height: 5.95238,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.9252,
    cy: 119.763,
    rx: 13.5737,
    ry: 13.5281,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.537,
    y: 104.611,
    width: 61.6883,
    height: 19.4805,
    rx: 1.08225,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.473,
    y: 104.611,
    width: 19.4805,
    height: 19.4805,
    rx: 1.08225,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3516 192.273H537.953V192.815H56.3516V192.273Z",
    fill: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.018,
    y: 158.164,
    width: 19.4805,
    height: 19.4805,
    rx: 1.08225,
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_105_31634",
    x: 0.205694,
    y: 0.244935,
    width: 533.446,
    height: 148.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.03924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.89715
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_31634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_105_31634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_105_31634",
    x: 24.2057,
    y: 83.2449,
    width: 533.446,
    height: 148.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.03924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.89715
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_31634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_105_31634",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryNoResults);
export default __webpack_public_path__ + "static/media/enquiry-no-results.62eb15df.svg";
export { ForwardRef as ReactComponent };